import { FC, useRef } from 'react';
import Image from 'next/image';
import Link from 'next/link';
import { useRouter } from 'next/router';
import { motion } from 'framer-motion';
import { ISuggestSearch } from '@modules/search/domain/models/suggestSearch.model';
import { ModuleType } from '@shared/types/module.type';
import { useHover } from '@shared/utils/hooks';
import { BulletCustom, Container, HighlighterCustom, SeeAll, SuggestText, Topic, Wrapper } from './SuggestSearch.style';
interface Props {
  searchValue: string;
  suggestSearch: ISuggestSearch;
  setIsSearchModalOpen: (val: boolean) => void;
}
const SuggestSearch: FC<Props> = ({
  searchValue,
  suggestSearch,
  setIsSearchModalOpen
}: Props) => {
  const router = useRouter();
  const seeAllProductRef = useRef(null);
  const seeAllProductHover = useHover(seeAllProductRef);
  const seeAllRecipeRef = useRef(null);
  const seeAllRecipeHover = useHover(seeAllRecipeRef);
  const seeAllTipsTricksRef = useRef(null);
  const seeAllTipsTricksHover = useHover(seeAllTipsTricksRef);
  const seeAllArrowMotionVariants = {
    mouseHover: {
      x: 3
    },
    mouseLeave: {
      x: 0
    }
  };
  const onClickSeeAll = () => {
    setIsSearchModalOpen(false);
    if (router.route === '/search') {
      setTimeout(() => {
        router.reload();
      }, 50);
    }
  };
  const handleOnClick = () => {
    setIsSearchModalOpen(false);
  };
  return <Container>
            {suggestSearch.products.length > 0 && <Wrapper>
                    <Topic>ผลิตภัณฑ์ซีพี</Topic>
                    <div>
                        {suggestSearch.products.map(item => <Link href={item.linkOut} key={item.id} onClick={handleOnClick}>
                                <SuggestText>
                                    <BulletCustom>
                                        <Image src="/icons/bullet.svg" alt="bullet icon" width={6} height={6} />
                                    </BulletCustom>
                                    <HighlighterCustom searchWords={[searchValue]} autoEscape={true} textToHighlight={item.text} />
                                </SuggestText>
                            </Link>)}
                        <Link href={`/search?q=${searchValue}&c=${ModuleType.Product}`} onClick={onClickSeeAll}>
                            <SeeAll ref={seeAllProductRef}>
                                <div className="text">ดูทั้งหมด</div>
                                <motion.img className="icon" src="/icons/arrow-right-black.svg" alt="arrow icon" animate={seeAllProductHover ? 'mouseHover' : 'mouseLeave'} variants={seeAllArrowMotionVariants} transition={{
              type: 'spring'
            }} />
                            </SeeAll>
                        </Link>
                    </div>
                </Wrapper>}
            {suggestSearch.recipe.length > 0 && <Wrapper>
                    <Topic>เมนูอาหาร</Topic>
                    <div>
                        {suggestSearch.recipe.map(item => <Link href={item.linkOut} key={item.id} onClick={handleOnClick}>
                                <SuggestText>
                                    <BulletCustom>
                                        <Image src="/icons/bullet.svg" alt="bullet icon" width={6} height={6} />
                                    </BulletCustom>
                                    <HighlighterCustom searchWords={[searchValue]} autoEscape={true} textToHighlight={item.text} />
                                </SuggestText>
                            </Link>)}
                        <Link href={`/search?q=${searchValue}&c=${ModuleType.Recipe}`} onClick={onClickSeeAll}>
                            <SeeAll ref={seeAllRecipeRef}>
                                <div className="text">ดูทั้งหมด</div>
                                <motion.img className="icon" src="/icons/arrow-right-black.svg" alt="arrow icon" animate={seeAllRecipeHover ? 'mouseHover' : 'mouseLeave'} variants={seeAllArrowMotionVariants} transition={{
              type: 'spring'
            }} />
                            </SeeAll>
                        </Link>
                    </div>
                </Wrapper>}
            {suggestSearch.tipsTricks.length > 0 && <Wrapper style={{
      marginBottom: '0px'
    }}>
                    <Topic>เคล็ดลับ</Topic>
                    <div>
                        {suggestSearch.tipsTricks.map(item => <Link href={item.linkOut} key={item.id} onClick={handleOnClick}>
                                <SuggestText>
                                    <BulletCustom>
                                        <Image src="/icons/bullet.svg" alt="bullet icon" width={6} height={6} />
                                    </BulletCustom>
                                    <HighlighterCustom searchWords={[searchValue]} autoEscape={true} textToHighlight={item.text} />
                                </SuggestText>
                            </Link>)}
                        <Link href={`/search?q=${searchValue}&c=${ModuleType.TipsTricks}`} onClick={onClickSeeAll}>
                            <SeeAll ref={seeAllTipsTricksRef}>
                                <div className="text">ดูทั้งหมด</div>
                                <motion.img className="icon" src="/icons/arrow-right-black.svg" alt="arrow icon" animate={seeAllTipsTricksHover ? 'mouseHover' : 'mouseLeave'} variants={seeAllArrowMotionVariants} transition={{
              type: 'spring'
            }} />
                            </SeeAll>
                        </Link>
                    </div>
                </Wrapper>}
        </Container>;
};
export default SuggestSearch;